/*
 * Copyright (C) 2019 - Potentially Ltd
 *
 * Please see distribution for license.
 */

import { ApiMentorMenteeDataService } from '@app/app/page-modules/admin/services/mentor-mentee/api-mentor-mentee-data.service';
import { MentorMenteeDataService } from '@app/app/page-modules/admin/services/mentor-mentee/mentor-mentee-data.service';
import { MockMentorMenteeDataService } from '@app/app/page-modules/admin/services/mentor-mentee/mock-mentor-mentee-data.service';
import { ApiEmployerMemberDataService } from '@app/app/page-modules/employer/services/api-employer-member-data.service';
import { EmployerMemberDataService } from '@app/app/page-modules/employer/services/employer-member-data.service';
import { MockEmployerMemberDataService } from '@app/app/page-modules/employer/services/mock-employer-member-data.service';
import { ApiReviewsDataService } from '@app/app/page-modules/reviews/services/api-data.service';
import { ReviewsDataService } from '@app/app/page-modules/reviews/services/data.service';
import { MockReviewsDataService } from '@app/app/page-modules/reviews/services/mock-data.service';
import { ApiBadgeDataService } from '@app/app/shared/services/badge/api-badge-data.service';
import { BadgeDataService } from '@app/app/shared/services/badge/badge-data.service';
import { MockBadgeDataService } from '@app/app/shared/services/badge/mock-badge-data.service';
import { ApiLearningExperiencesService } from '@app/app/shared/services/learning-experiences/api-learning-experiences.service';
import { LearningExperiencesService } from '@app/app/shared/services/learning-experiences/learning-experiences.service';
import { MockLearningExperiencesService } from '@app/app/shared/services/learning-experiences/mock-learning-experiences.service';
import { PortfolioDataService } from '@app/app/shared/services/portfolio/data.service';
import { MockPortfolioDataService } from '@app/app/shared/services/portfolio/mock-data.service';
import { TranslocoService } from '@ngneat/transloco';
import { environment } from '../../environments/environment';
import { AllContentDataService } from '../page-modules/admin/services/all-content/all-content-data.service';
import { ApiAllContentDataService } from '../page-modules/admin/services/all-content/api-all-content-data.service';
import { MockAllContentDataService } from '../page-modules/admin/services/all-content/mock-all-content-data.service';
import { ApiUserGroupsDataService } from '../page-modules/admin/services/groups/groups-api-data.service';
import { UserGroupsDataService } from '../page-modules/admin/services/groups/groups-data.service';
import { MockUserGroupsDataService } from '../page-modules/admin/services/groups/groups-mock-data.service';
import { ApiUnsplashImagesDataService } from '../page-modules/admin/services/images/api-unsplash-images-data.service';
import { MockUnsplashImagesDataService } from '../page-modules/admin/services/images/mock-unsplash-images-data.service';
import { UnsplashImagesDataService } from '../page-modules/admin/services/images/unsplash-images-data.service';
import { ApiImportUsersService } from '../page-modules/admin/services/import-members/api-import-users.service';
import { ImportUsersService } from '../page-modules/admin/services/import-members/import-users.service';
import { MockImportUsersService } from '../page-modules/admin/services/import-members/mock-import-users.service';
import { ApiMembersDataService } from '../page-modules/admin/services/members/api-members-data.service';
import { MembersDataService } from '../page-modules/admin/services/members/members-data.service';
import { MockMembersDataService } from '../page-modules/admin/services/members/mock-members-data.service';
import { ApiRolesDataService } from '../page-modules/admin/services/roles/api-roles-data.service';
import { MockRolesDataService } from '../page-modules/admin/services/roles/mock-roles-data.service';
import { RolesDataService } from '../page-modules/admin/services/roles/roles-data.service';
import { ApiOrganizationDataService } from '../page-modules/admin/super-admin/organizations/services/api-data.service';
import { OrganizationsDataService } from '../page-modules/admin/super-admin/organizations/services/data.service';
import { MockOrganizationsDataService } from '../page-modules/admin/super-admin/organizations/services/mock-data.service';
import { ApiCourseDataService } from '../page-modules/course/services/create/core/api-data.service';
import { CourseDataService } from '../page-modules/course/services/create/core/data.service';
import { MockCourseDataService } from '../page-modules/course/services/create/core/mock-data.service';
import { ApiDiagnosticsDataService } from '../page-modules/diagnostics/services/api-data.service';
import { DiagnosticsDataService } from '../page-modules/diagnostics/services/data.service';
import { MockDiagnosticsDataService } from '../page-modules/diagnostics/services/mock-data.service';
import { ApiEventCardsDataService } from '../page-modules/event-cards/services/api-data.service';
import { EventCardsDataService } from '../page-modules/event-cards/services/data.service';
import { MockEventCardsDataService } from '../page-modules/event-cards/services/mock-data.service';
import { ApiFolioDataService } from '../page-modules/folio/services/api-data.service';
import { FolioDataService } from '../page-modules/folio/services/data.service';
import { MockFolioDataService } from '../page-modules/folio/services/mock-data.service';
import { ApiGlobalSearchDataService } from '../page-modules/global-search/services/global-search-api-data.service';
import { GlobalSearchDataService } from '../page-modules/global-search/services/global-search-data.service';
import { MockGlobalSearchDataService } from '../page-modules/global-search/services/global-search-mock-data.service';
import { ApiPageDataService } from '../page-modules/pages/services/api-data.service';
import { PageDataService } from '../page-modules/pages/services/data.service';
import { MockPageDataService } from '../page-modules/pages/services/mock-data.service';
import { ApiCardsDataService } from '../page-modules/playlist/services/create/cards/api-data.service';
import { MockPlaylistResourceCardsDataService } from '../page-modules/playlist/services/create/cards/mock-data.service';
import { ApiPlaylistDataService } from '../page-modules/playlist/services/create/core/api-data.service';
import { PlaylistDataService } from '../page-modules/playlist/services/create/core/data.service';
import { MockPlaylistDataService } from '../page-modules/playlist/services/create/core/mock-data.service';
import { ApiPublicationDataService } from '../page-modules/playlist/services/create/publication/api-publication-data.service';
import { MockPublicationDataService } from '../page-modules/playlist/services/create/publication/mock-publication-data.service';
import { PublicationDataService } from '../page-modules/playlist/services/create/publication/publication-data.service';
import { ApiCourseAnalyticsDataService } from '../page-modules/programs/services/analytics/api-course-analytics-data.service';
import { ApiProgramAnalyticsDataService } from '../page-modules/programs/services/analytics/api-program-analytics-data.service';
import { CoursesAnalyticsDataService } from '../page-modules/programs/services/analytics/courses-analytics-data.service';
import { MockCourseAnalyticsDataService } from '../page-modules/programs/services/analytics/mock-course-analytics-data.service';
import { MockProgramAnalyticsDataService } from '../page-modules/programs/services/analytics/mock-program-analytics-data.service';
import { ApiProgramDataService } from '../page-modules/programs/services/create/core/api-data.service';
import { ProgramDataService } from '../page-modules/programs/services/create/core/data.service';
import { MockProgramDataService } from '../page-modules/programs/services/create/core/mock-data.service';
import { ApiProjectDataService } from '../page-modules/project/services/api-data.service';
import { ProjectDataService } from '../page-modules/project/services/data.service';
import { MockProjectDataService } from '../page-modules/project/services/mock-data.service';
import { ApiLearnerViewDataService } from '../page-modules/resource/services/api-data.service';
import { LearnerViewDataService } from '../page-modules/resource/services/data.service';
import { ApiResourceDataService } from '../page-modules/resource/services/editor/core/api-data.service';
import { ResourceDataService } from '../page-modules/resource/services/editor/core/data.service';
import { MockResourceDataService } from '../page-modules/resource/services/editor/core/mock-data.service';
import { MockLearnerViewDataService } from '../page-modules/resource/services/mock-data.service';
import { ApiBookingDataService } from './services/booking/api-booking-data.service';
import { BookingDataService } from './services/booking/booking-data.service';
import { MockBookingDataService } from './services/booking/mock-booking-data.service';
import { ApiCompetenceDataService } from './services/competence/api-competence-data.service';
import { CompetenceDataService } from './services/competence/competence-data.service';
import { MockCompetenceDataService } from './services/competence/mock-competence-data.service';
import { ApiContentPackageDataService } from './services/content-package/api-content-package-data.service';
import { ContentPackageDataService } from './services/content-package/content-package-data.service';
import { MockContentPackageDataService } from './services/content-package/mock-content-package-data.service';
import { ApiHelpCenterDataService } from './services/help-center/api-help-center-data.service';
import { HelpCenterDataService } from './services/help-center/help-center-data.service';
import { MockHelpCenterDataService } from './services/help-center/mock-help-center-data.service';
import { ApiPortfolioDataService } from './services/portfolio/api-data.service';
import { RequestQueueManagerService } from './services/request-queue-manager/request-queue-manager';
import { RestClientService } from './services/rest-client.service';
import { ApiSharedUpcomingDataService } from './services/upcoming/api-upcoming-data.service';
import { MockSharedUpcomingDataService } from './services/upcoming/mock-upcoming-data.service';
import { SharedUpcomingDataService } from './services/upcoming/upcoming-data.service';

export function membersServiceFactory(client: RestClientService, translocoService: TranslocoService): MembersDataService {
  if (environment.dataProvider === 'mock') {
    return new MockMembersDataService();
  }

  return new ApiMembersDataService(client, translocoService);
}

export function playlistServiceFactory(client: RestClientService, translocoService: TranslocoService): PlaylistDataService {
  if (environment.dataProvider === 'mock') {
    return new MockPlaylistDataService();
  }

  return new ApiPlaylistDataService(client, translocoService);
}

export function courseServiceFactory(client: RestClientService, translocoService: TranslocoService): CourseDataService {
  if (environment.dataProvider === 'mock') {
    return new MockCourseDataService();
  }

  return new ApiCourseDataService(client, translocoService);
}

/** Provides the reviews data service. */
export function reviewsDataServiceFactory(client: RestClientService, translocoService: TranslocoService): ReviewsDataService {
  if (environment.dataProvider === 'mock') {
    return new MockReviewsDataService();
  }

  return new ApiReviewsDataService(client, translocoService);
}

/** Provides the core resource data service. */
export function resourceServiceFactory(
  client: RestClientService,
  translocoService: TranslocoService,
  requestQueueManager: RequestQueueManagerService<unknown>,
): ResourceDataService {
  if (environment.dataProvider === 'mock') {
    return new MockResourceDataService();
  }

  return new ApiResourceDataService(client, translocoService, requestQueueManager);
}

export function rolesServiceFactory(client: RestClientService, translocoService: TranslocoService): RolesDataService {
  if (environment.dataProvider === 'mock') {
    return new MockRolesDataService();
  }

  return new ApiRolesDataService(client, translocoService);
}

// -------------------------------------------------------------------------
/** Provides the playlist cards data service. */
export function playlistCardsServiceFactory(client: RestClientService, translocoService: TranslocoService) {
  if (environment.dataProvider === 'mock') {
    return new MockPlaylistResourceCardsDataService();
  }

  return new ApiCardsDataService(client, translocoService);
}

export function userGroupsServiceFactory(client: RestClientService, translocoService: TranslocoService): UserGroupsDataService {
  if (environment.dataProvider === 'mock') {
    return new MockUserGroupsDataService();
  }

  return new ApiUserGroupsDataService(client, translocoService);
}

// -------------------------------------------------------------------------
/** Provides the core organization data service. */
export function organizationsServiceFactory(client: RestClientService, translocoService: TranslocoService): OrganizationsDataService {
  if (environment.dataProvider === 'mock') {
    return new MockOrganizationsDataService();
  }

  return new ApiOrganizationDataService(client, translocoService);
}

// -------------------------------------------------------------------------
/** Provides the playlist publication data service. */
export function playlistPublicationServiceFactory(client: RestClientService, translocoService: TranslocoService): PublicationDataService {
  if (environment.dataProvider === 'mock') {
    return new MockPublicationDataService();
  }

  return new ApiPublicationDataService(client, translocoService);
}

// -------------------------------------------------------------------------
/** Provides the playlist goal data service. */
export function globalSearchServiceFactory(client: RestClientService, translocoService: TranslocoService): GlobalSearchDataService {
  if (environment.dataProvider === 'mock') {
    return new MockGlobalSearchDataService();
  }

  return new ApiGlobalSearchDataService(client, translocoService);
}

export function competenceServiceFactory(client: RestClientService, translocoService: TranslocoService): CompetenceDataService {
  if (environment.dataProvider === 'mock') {
    return new MockCompetenceDataService();
  }

  return new ApiCompetenceDataService(client, translocoService);
}

export function pageServiceFactory(client: RestClientService, translocoService: TranslocoService): PageDataService {
  if (environment.dataProvider === 'mock') {
    return new MockPageDataService();
  }

  return new ApiPageDataService(client, translocoService);
}

export function upcomingServiceFactory(client: RestClientService, translocoService: TranslocoService): SharedUpcomingDataService {
  if (environment.dataProvider === 'mock') {
    return new MockSharedUpcomingDataService();
  }

  return new ApiSharedUpcomingDataService(client, translocoService);
}

export function helpCenterServiceFactory(client: RestClientService, translocoService: TranslocoService): HelpCenterDataService {
  if (environment.dataProvider === 'mock') {
    return new MockHelpCenterDataService();
  }

  return new ApiHelpCenterDataService(client, translocoService);
}

// -------------------------------------------------------------------------
/** Provides the data service. */
export function resourceLearnerViewServiceFactory(client: RestClientService, translocoService: TranslocoService): LearnerViewDataService {
  if (environment.dataProvider === 'mock') {
    return new MockLearnerViewDataService();
  }

  return new ApiLearnerViewDataService(client, translocoService);
}

// -------------------------------------------------------------------------
/** Provides the data service. */
export function diagnosticsServiceFactory(client: RestClientService, translocoService: TranslocoService): DiagnosticsDataService {
  if (environment.dataProvider === 'mock') {
    return new MockDiagnosticsDataService();
  }

  return new ApiDiagnosticsDataService(client, translocoService);
}

export function contentStoreFactory(client: RestClientService, translocoService: TranslocoService): ContentPackageDataService {
  if (environment.dataProvider === 'mock') {
    return new MockContentPackageDataService();
  }

  return new ApiContentPackageDataService(client, translocoService);
}

export function bookingServiceFactory(client: RestClientService, translocoService: TranslocoService): BookingDataService {
  if (environment.dataProvider === 'mock') {
    return new MockBookingDataService();
  }

  return new ApiBookingDataService(client, translocoService);
}

export function unsplashServiceFactory(client: RestClientService, translocoService: TranslocoService): UnsplashImagesDataService {
  if (environment.dataProvider === 'mock') {
    return new MockUnsplashImagesDataService();
  }

  return new ApiUnsplashImagesDataService(client, translocoService);
}

export function eventCardsServiceFactory(client: RestClientService, translocoService: TranslocoService): EventCardsDataService {
  if (environment.dataProvider === 'mock') {
    return new MockEventCardsDataService();
  }
  return new ApiEventCardsDataService(client, translocoService);
}

export function importUsersServiceFactory(client: RestClientService, translocoService: TranslocoService): ImportUsersService {
  if (environment.dataProvider === 'mock') {
    return new MockImportUsersService();
  }

  return new ApiImportUsersService(client, translocoService);
}

export function allContentServiceFactory(client: RestClientService, translocoService: TranslocoService): AllContentDataService {
  if (environment.dataProvider === 'mock') {
    return new MockAllContentDataService();
  }
  return new ApiAllContentDataService(client, translocoService);
}

export function folioServiceFactory(client: RestClientService, translocoService: TranslocoService): FolioDataService {
  if (environment.dataProvider === 'mock') {
    return new MockFolioDataService();
  }

  return new ApiFolioDataService(client, translocoService);
}

export function projectServiceFactory(client: RestClientService, translocoService: TranslocoService): ProjectDataService {
  if (environment.dataProvider === 'mock') {
    return new MockProjectDataService();
  }

  return new ApiProjectDataService(client, translocoService);
}

export function learningExperiencesServiceFactory(client: RestClientService): LearningExperiencesService {
  if (environment.dataProvider === 'mock') {
    return new MockLearningExperiencesService();
  }

  return new ApiLearningExperiencesService(client);
}

export function mentorMenteeServiceFactory(client: RestClientService, translocoService: TranslocoService): MentorMenteeDataService {
  if (environment.dataProvider === 'mock') {
    return new MockMentorMenteeDataService();
  }

  return new ApiMentorMenteeDataService(client, translocoService);
}

export function badgeServiceFactory(client: RestClientService, translocoService: TranslocoService): BadgeDataService {
  if (environment.dataProvider === 'mock') {
    return new MockBadgeDataService();
  }

  return new ApiBadgeDataService(client, translocoService);
}

export function portfolioServiceFactory(client: RestClientService, translocoService: TranslocoService): PortfolioDataService {
  if (environment.dataProvider === 'mock') {
    return new MockPortfolioDataService();
  }

  return new ApiPortfolioDataService(client, translocoService);
}

export function programServiceFactory(client: RestClientService, translocoService: TranslocoService): ProgramDataService {
  if (environment.dataProvider === 'mock') {
    return new MockProgramDataService();
  }

  return new ApiProgramDataService(client, translocoService);
}

export function programAnalyticsServiceFactory(client: RestClientService, translocoService: TranslocoService): CoursesAnalyticsDataService {
  if (environment.dataProvider === 'mock') {
    return new MockProgramAnalyticsDataService();
  }

  return new ApiProgramAnalyticsDataService(client, translocoService);
}

export function courseAnalyticsServiceFactory(client: RestClientService, translocoService: TranslocoService): CoursesAnalyticsDataService {
  if (environment.dataProvider === 'mock') {
    return new MockCourseAnalyticsDataService();
  }

  return new ApiCourseAnalyticsDataService(client, translocoService);
}

export function employerMemberDataServiceFactory(client: RestClientService, translocoService: TranslocoService): EmployerMemberDataService {
  if (environment.dataProvider === 'mock') {
    return new MockEmployerMemberDataService();
  }
  return new ApiEmployerMemberDataService(client, translocoService);
}
